import { StrictMode } from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { ImpersonationContextProvider } from "@gui/contexts/impersonation";
import * as Sentry from "@sentry/react";
import { initPerformanceMonitoring } from "@gui/infrastructure/pass-through/sentryPerformance";
import { initSentry } from "./sentry";
import { Browser } from "@gui/infrastructure/pass-through/browser";
import { env } from "@gui/infrastructure/pass-through/env";

// Enable react-scan for re-render visualization (dev only, when VITE_REACT_SCAN is set)
if (env.isDev && env.reactScan) {
	import("react-scan").then(({ scan }) => {
		scan({ enabled: true, log: true });
	});
}

initSentry();

// Before the tree renders: a lazy route whose chunk cannot be fetched reloads the page
// instead of crashing it into the error boundary.
Browser.installAssetPreloadRecovery();

// Initialize Web Vitals monitoring
// - Dev: logs to console AND sends to Sentry
// - Prod: sends to Sentry only (breadcrumbs + alerts for poor metrics)
const isDev = env.environmentName === "development";
initPerformanceMonitoring(isDev ? "both" : "sentry");

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
	<Sentry.ErrorBoundary
		fallback={
			<>
				<p>
					An unexpected error has occurred. The ROGO software team has been notified. Please reach out to
					software@rogoag.com or use our{" "}
					<a href="https://airtable.com/appG2uelyCZuENMT8/pagzG52leZoMbzYb8/form" target="_blank" rel="noreferrer">
						software feedback form
					</a>{" "}
					with any additional questions or concerns.
				</p>
				<p>
					Please try to refresh your browser and visit{" "}
					<a href="https://portal.rogoag.com/jobs/dashboard">your dashboard</a> again
				</p>
			</>
		}
	>
		<StrictMode>
			<ImpersonationContextProvider>
				<App />
			</ImpersonationContextProvider>
		</StrictMode>
	</Sentry.ErrorBoundary>,
);
